import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import PartInventoryInternalList from "./PartInventoryInternalList";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { getReservesDetails } from "../../services/PartsInventory";
import InternalPendingList from "./InternalPendingList";
import AddInternalClient from "./AddInternalClient";

const AddInternal = () => {
  const [step, setStep] = useState(1);
  const [reserveData, setReserveData] = useState(null);
  const [partIdData, setPartIdData] = useState(null);
  const [reserveDetails, setReserveDetails] = useState([]);
  const [partNewData, setPartNewData] = useState(null);

  const { state } = useLocation();
  const { uuid } = useParams();

  useEffect(() => {
    if (uuid) {
      let data = {
        uuid: uuid,
      };
      getReservesDetails(data)
        .then((response) => {
          setReserveDetails(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, []);

  return (
    <div>
      {step === 1 && (
        <PartInventoryInternalList
          state={state}
          setStep={setStep}
          step={step}
          setReserveData={setReserveData}
          reserveData={reserveData}
          setPartIdData={setPartIdData}
          partIdData={partIdData}
          reserveDetails={reserveDetails}
          setPartNewData={setPartNewData}
          partNewData={partNewData}
        />
      )}

      {step === 2 && (
        <InternalPendingList
          state={state}
          setStep={setStep}
          step={step}
          reserveData={reserveData}
          setReserveData={setReserveData}
          setPartIdData={setPartIdData}
          partIdData={partIdData}
          reserveDetails={reserveDetails}
          setPartNewData={setPartNewData}
          partNewData={partNewData}
        />
      )}

     
    </div>
  );
};

export default AddInternal;
